export default "__VITE_ASSET__D1cQRf85__"